module.exports = __webpack_public_path__ + "static/media/mc_controls.5dc7f261.svg";